import {appBackground} from '@hconnect/hub/src/App.styles'
import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
  root: {
    top: '64px !important'
  },
  frameStyle: {
    width: '480px',
    height: '100vh',
    margin: '0 auto',
    border: '1px solid #2196F3',
    padding: '10px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'auto'
  },
  headerLogoContainer: {
    marginBottom: theme.spacing(1)
  },
  navItemClassName: {
    color: '#FFFFFF'
  },
  activeNavItemClassName: {
    color: 'rgba(255, 255, 255, 0.5)',
    borderBottom: '2px solid rgba(255, 255, 255, 0.5)'
  },
  mhcHeader: {
    '& [data-test-id="overlay"][data-value="open"]': {
      background: appBackground
    },
    '& [data-test-id="burger-menu"][type="button"]': {
      boxShadow: 'none',
      background: 'rgba(128,180,223) '
    }
  }
}))
